export const en = {
    'show-all-text': 'Show all streams'
};
